/* eslint-disable import/prefer-default-export */
import { useEffect, useState, useCallback } from 'react';
import { cloneDeep, find } from 'lodash';
import { useSelector } from 'react-redux';

import {
  filterIntegerInput,
  filterFloatValue,
  isNumeric
} from '../../../../util/customFieldDataTypes';

export const useOrderCustomFields = ({ getValues, setValue }) => {
  const { selectedCustomFields } = useSelector(
    (state) => state.customFieldsReducer
  );

  const [splittedFields, setSplittedFields] = useState([]);
  const [toggleKey, setToggleKey] = useState(0);

  useEffect(() => {
    const fields = cloneDeep(selectedCustomFields);
    const result = [];

    while (fields?.length > 0) {
      result.push(fields.splice(0, 2));
    }

    setSplittedFields(result);
  }, [selectedCustomFields]);

  const updateCustomField = useCallback(
    (field, value) => {
      setValue(`customFields.${field.name}`, value, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true
      });

      setValue(
        'customAnswers',
        ((prev) => {
          const cloned = [...(prev || [])];
          const index = cloned.findIndex(
            (ca) => ca.custom_field_id === field.id
          );

          let newAnswer = String(value);

          if (field.kind === 'list') {
            const selectedField = find(
              field.list_options,
              (option) => String(option.id) === String(newAnswer) || String(option.value) === String(newAnswer)
            );
            if (selectedField) newAnswer = selectedField.value;
          }

          if (index >= 0) {
            cloned[index] = { ...cloned[index], answer: newAnswer };
          } else {
            cloned.push({
              custom_field_id: field.id,
              answer: newAnswer
            });
          }

          return cloned;
        })(getValues('customAnswers')),
        { shouldDirty: true }
      );
    },
    [getValues, setValue]
  );

  const handleInputChange = useCallback(
    (event, field) => {
      const { value } = event.target;
      let filtered = value;

      if (field.kind === 'integer') {
        filtered = filterIntegerInput(value);
      }

      if (field.kind === 'float') {
        filtered = isNumeric(value)
          ? filterFloatValue(value)
          : getValues(`customFields.${field.name}`);
      }

      updateCustomField(field, filtered);
    },
    [getValues, updateCustomField]
  );

  const handleBooleanToggle = useCallback(
    (field) => {
      const current = getValues(`customFields.${field.name}`) ?? false;

      updateCustomField(field, !current);
      setToggleKey((k) => k + 1);
    },
    [getValues, updateCustomField]
  );

  return {
    splittedFields,
    getValues,
    updateCustomField,
    handleInputChange,
    handleBooleanToggle,
    toggleKey
  };
};
